import Image from 'next/image';

import { Box, FormField, Heading, Input, Label, Paragraph, Text } from '@zillow/constellation-10';

import { AGENT_HANDSHAKE_ILLUSTRATION_URL } from '../../../../../constants/DigitalLibraryConstants';

import type { ChangeEvent } from 'react';

type NameFieldsProps = {
  firstName: string;
  lastName: string;
  onFirstNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onLastNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
  questionNumber: number;
  questionTotal: number;
};

export const NameFields = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  questionNumber,
  questionTotal,
}: NameFieldsProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '500',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Box aria-hidden="true">
        <Image priority width={120} height={120} src={AGENT_HANDSHAKE_ILLUSTRATION_URL} alt="" />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
        <Text textStyle="body-xs-bold" css={{ color: 'text.subtle' }}>
          Question {questionNumber} of {questionTotal}
        </Text>
        <Heading level={2} textStyle="heading-xs">
          What’s your name?
        </Heading>
        <Paragraph>We’ll use this to personalize your experience.</Paragraph>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', width: '100%' }}>
        <FormField
          label={<Label>First name</Label>}
          control={<Input value={firstName} onChange={onFirstNameChange} />}
        />
        <FormField label={<Label>Last name</Label>} control={<Input value={lastName} onChange={onLastNameChange} />} />
      </Box>
    </Box>
  );
};

export default NameFields;
